import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import Utility from './Utility';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import Lib from '../../../commons/lib';
import ProgressButton from '../../../commons/ProgressButton';

class NaptarTipusConent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      insert: true,
      modalNaptartipus: false,
      modalNaptartipusTorles: false,
      helyszinek: [],
      naptartipusok: [],
      naptartipusModositObj: {},
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateTable();
    this.listHelyszin();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '1' && this.props.activeTab === '1') {
      this.updateTable();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'], true);
  }

  listHelyszin = () => {
    Service.listPublicHelyszin('OSSZES', (err, res) => {
      if (!err) {
        this.setState({ helyszinek: res[0] });
        if(!this.state.helyszin && res[0].length === 1) {
          this.setState({ helyszin: res[0][0] });
        }
      }
    });
  }

  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' }, () => {
      Service.listNaptartipus(null, (err, res) => {
        if (!err) {
          let status = res[0].length == 0 ? 'DATA' : 'TABL';
          this.setState({ naptartipusok: res[0], tableStatus: status });
        } else {
          this.setState({ tableStatus: 'NETW' });
        }
      });
    });
  }

  toggleNaptartipus = () => {
    this.setState((prevState) => { return ({ modalNaptartipus: !prevState.modalNaptartipus }); });
  }

  toggleNaptartipusView = () => {
    this.setState((prevState) => { return ({ modalNaptartipusView: !prevState.modalNaptartipusView }) });
  }

  toggleNaptartipusTorles = () => {
    this.setState((prevState) => { return ({ modalNaptartipusTorles: !prevState.modalNaptartipusTorles }); });
  }

  handleNaptartipusAddClick = () => {
    this.setState({ insert: true, naptartipusModositObj: {} });
    this.toggleNaptartipus();
  }

  handleNaptartipusViewClick = (id) => {
    this.setState((prevState) => {
      const naptartipus = prevState.naptartipusok.find(element => element.id === id);
      return ({ naptartipusModositObj: naptartipus });
    });
    this.toggleNaptartipusView();
  }

  handleNaptartipusEditClick = (id) => {
    this.setState((prevState) => {
      const naptartipus = prevState.naptartipusok.find(element => element.id === id);
      return ({ naptartipusModositObj: naptartipus, insert: false, helyszin: { id: naptartipus.helyszinid, nev: naptartipus.helyszinnev } });
    });
    this.toggleNaptartipus();
  }

  handleNaptartipusDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleNaptartipusTorles();
  }

  iconFormatter = (cell) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleNaptartipusViewClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {
          this.hasRoleKarb()
            ? (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleNaptartipusEditClick(cell)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleNaptartipusDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
              </React.Fragment>
            )
            : <div />
        }


      </div>
    );
  }

  addNaptartipus = (event, naptartipusObj) => {
    naptartipusObj.helyszinid = this.state.helyszin && this.state.helyszin.id;
    naptartipusObj.hetvege = naptartipusObj.hetvege || false;
    naptartipusObj.aktiv = naptartipusObj.aktiv || false;
    this.setState({ addButtonLoading: true });
    Service.addNaptartipus(naptartipusObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleNaptartipus();
        this.props.globals.addSuccess('Naptártípus hozzáadva!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  modifyNaptartipus = (event, naptartipusObj) => {
    naptartipusObj.id = this.state.naptartipusModositObj.id;
    naptartipusObj.helyszinid = this.state.helyszin && this.state.helyszin.id;
    naptartipusObj.hetvege = naptartipusObj.hetvege || false;
    naptartipusObj.aktiv = naptartipusObj.aktiv || false;
    this.setState({ modifyButtonLoading: true });
    Service.editNaptartipus(naptartipusObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleNaptartipus();
        this.props.globals.addSuccess('Naptártípus módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteNaptartipus = () => {
    this.toggleNaptartipusTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteNaptartipus(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Naptártípus törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  statusFormatter = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Aktív</span>;
      case false:
        return <span className="badge badge-default">Inaktív</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  statusFormatterHetvege = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Igen</span>;
      case false:
        return <span className="badge badge-default">Nem</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  renderTable = () => {
    const selectOptionsAllapot = [
      { value: true, label: 'Aktív' },
      { value: false, label: 'Inaktív' }
    ];
    const selectOptionsHetvege = [
      { value: true, label: 'Igen' },
      { value: false, label: 'Nem' }
    ];

    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'helyszinnev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'aktiv',
        text: 'Állapot',
        filter: selectFilter({
          options: selectOptionsAllapot,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      },
      {
        dataField: 'hetvege',
        text: 'Hétvége',
        filter: selectFilter({
          options: selectOptionsHetvege,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatterHetvege,
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.naptartipusok}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb() ?
              (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleNaptartipusAddClick}>Új naptártípus</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.renderState()}
        <Modal isOpen={this.state.modalNaptartipus} toggle={this.toggleNaptartipus} className={this.props.className} backdrop="static">
          <RFForm onSubmit={this.state.insert ? this.addNaptartipus : this.modifyNaptartipus}>
            <ModalHeader>Naptártípus {this.state.insert ? 'felvétel' : 'módosítás'}</ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-md-12" style={{ paddingBottom: 10 }}>
                  <SelectField
                    required
                    label='Helyszín:'
                    name="helyszin"
                    id="helyszin"
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    loadingMessage={() => 'Keresés...'}
                    onChange={v => this.setState({ helyszin: v }) }
                    placeholder="Válassz helyszínt..."
                    options={this.state.helyszinek}
                    value={this.state.helyszin}
                    isDisabled={!this.state.insert}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option.nev}
                  />
                </div>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label={'Név: *'}
                      name="nev"
                      id="nev"
                      value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.nev}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label={'Azonosító: *'}
                      name="azonosito"
                      id="azonosito"
                      value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.azonosito}
                      disabled={!this.state.insert}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div>
                    <RFField
                      label={'Napszám: *'}
                      name="napszam"
                      id="napszam"
                      validate={(value) => {
                        if (value < 1) {
                          return 'A napszámnak 1 és 10 között kell lennie!';
                        }
                        if (value > 10) {
                          return 'A napszámnak 1 és 10 között kell lennie!';
                        }
                      }}
                      value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.napszam}
                      required
                      numberOnlyWhole
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div>
                    <RFField
                      label={'Óratördelés: *'}
                      name="oratordeles"
                      id="oratordeles"
                      numberOnlyWhole
                      required
                      value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.oratordeles}
                    />
                  </div>
                </div>
                <div className='col-auto' style={{ marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
                  <RFField
                    label={'Hétvége'}
                    type="checkbox"
                    name="hetvege"
                    id="hetvege"
                    value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.hetvege}
                  />
                </div>
                <div className='col-auto' style={{ marginTop: '35px', paddingLeft: '10px', paddingRight: '0px' }}>
                  <RFField
                    label={'Aktív'}
                    type="checkbox"
                    name="aktiv"
                    id="aktiv"
                    value={this.state.naptartipusModositObj && this.state.naptartipusModositObj.aktiv}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <ProgressButton color="primary" loading={this.state.insert ? this.state.addButtonLoading : this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
              <Button type="button" color="secondary" onClick={this.toggleNaptartipus}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalNaptartipusView} toggle={this.toggleNaptartipusView} className={this.props.className} backdrop="static">
          <ModalHeader>
            Megtekintés
          </ModalHeader>
          <ModalBody>
            <div>
              <h6>Adatok</h6>
              <b>Név: </b>{this.state.naptartipusModositObj.nev}<br />
              <b>Azonosító: </b>{this.state.naptartipusModositObj.azonosito}<br />
              <b>Helyszín: </b>{this.state.naptartipusModositObj.helyszinnev}<br />
              <b>Állapot: </b>{this.state.naptartipusModositObj.aktiv ? 'Aktív' : 'Inaktív'}<br />
              <b>Napok: </b>{this.state.naptartipusModositObj.napszam}<br />
              <b>Óratördelés: </b>{this.state.naptartipusModositObj.oratordeles}<br />
              <b>Hétvége: </b>{this.state.naptartipusModositObj.hetvege ? 'Igen' : 'Nem'}<br />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleNaptartipusView}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalNaptartipusTorles} toggle={this.toggleNaptartipusTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a naptártípust?</ModalBody>
          <ModalFooter>
            <ProgressButton color="primary" onClick={this.deleteNaptartipus} loading={this.state.deleteButtonLoading}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleNaptartipusTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default NaptarTipusConent;
